import { render } from "./Prijzen.vue?vue&type=template&id=1d943d50"
import script from "./Prijzen.vue?vue&type=script&lang=js"
export * from "./Prijzen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kyleb\\OneDrive\\Documenten\\Tess website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__